import {
	Box,
	SegmentedProgressBar,
	Spacer,
	Typography,
	WidgetCard,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { SegmentedProgressBarRef } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/molecules/SegmentedProgressBar/SegmentedProgressBar.models';
import { rem } from '@helpers';
import { useCarouselDetails } from '@hooks';
import { Anything, Color } from '@types';
import React, { useState } from 'react';

export const Carousel: React.FC = () => {
	const [activeIndex, setActiveIndex] = useState<number>(0);
	const resources = useCarouselDetails();
	const segmentedProgressBarRef = React.useRef<SegmentedProgressBarRef>(null);

	const timeAnimation = () => {
		const time = parseInt(resources[activeIndex]?.timeAnimation);
		return !isNaN(time) ? time * 1000 : 10000;
	};

	return (
		<Box
			styles={{
				backgroundImage: `url(${resources[activeIndex]?.imageUrl})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				transitionProperty: 'background',
				transitionDuration: '1s',
				transitionTimingFunction: 'ease-in-out',
				height: '100%',
				width: '100%',
			}}
		>
			<Box
				styles={{
					height: '100%',
					width: '100%',
					justifyContent: 'flex-end',
					alignItems: 'flex-end',
				}}
			>
				<WidgetCard
					appearance="tertiary"
					container={
						{
							padding: rem(24, 24, 32),
							width: rem(400),
							margin: rem(0, 40, 40, 0),
						} as Anything
					}
					innerContainerProps={{
						padding: 'unset',
						margin: 'unset',
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<div>
						<Typography appearance="subtitle-200-02">{resources[activeIndex]?.title}</Typography>
					</div>
					<Spacer vertical={16} />
					<div>
						<Typography appearance="body-100-02">{resources[activeIndex]?.subtitle}</Typography>
					</div>
					<Spacer vertical={16} />
					{resources.length && (
						<SegmentedProgressBar
							ref={segmentedProgressBarRef}
							numberOfItems={resources.length}
							activeIndex={activeIndex}
							onChange={(index: number) => setActiveIndex(index)}
							animationProgressDuration={timeAnimation()}
							onSegmentedProgressFinish={segmentedProgressBarRef.current?.reset}
							playState={'running'}
							contentProps={{ backgroundColor: Color.Izibizi, borderRadius: rem(8) }}
						/>
					)}
				</WidgetCard>
			</Box>
		</Box>
	);
};
